<template>
    <div class="documents-card card mx-0 px-0" style="min-height: 200px;">
        <div class="card-header d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 mx-3">
            <h3 class="mb-0 mb-sm-0">Support Resources</h3>
            <!-- <div class="btn-group" role="group" aria-label="Card actions">
                <Button type="primary" class="btn-sm" icon="fas fa-file-upload" modal="support-modal">Upload
                    Document</Button>
                <Button type="secondary" class="btn-sm">Upload Document</button>
            </div> -->

            <div class="d-flex align-items-center gap-2 mt-2 mt-sm-0">
                <button v-if="isManageMode" class="btn btn-primary" @click="openAddDocumentModal">
                    <img class="icon" src="/img/icons/avid-icons/plus.svg" alt=""> Add {{ activeTab === 'videos' ? 'Video' : 'Document' }}
                </button>
                <nav class="navbar navbar-expand secondary-tab-bar" style="box-shadow: none;">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link d-flex flex-nowrap secondary-tab"
                                :class="{ 'secondary-tab-active': activeTab === 'videos' }" href="#"
                                @click.prevent="switchTab('videos')"><span>Videos</span></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link d-flex flex-nowrap secondary-tab"
                                :class="{ 'secondary-tab-active': activeTab === 'documents' }" href="#"
                                @click.prevent="switchTab('documents')"><span>Documents</span></a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="card-body p-0" v-show="activeTab === 'videos'">
            <div class="container-fluid px-4" :class="documents.length > 6 ? 'pb-5' : 'pb-4'" v-if="documents.length > 0">
                <div class="row">
                    <div class="mb-2" v-for="(document, index) in displayedVideos" :key="document.id"
                         :class="[
                             displayedVideos.length === 1 ? 'col-12' : 'col-md-6',
                             { 'border-end d-none d-md-block': index % 2 === 0 && index < displayedVideos.length - 1 && displayedVideos.length > 1 }
                         ]">
                        <div class="d-flex align-items-start mb-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="video-play-icon">
                                     <img class="icon" src="/img/icons/avid-icons/video.svg" alt=""></img>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h6 class="mb-1">
                                    <a
                                        v-if="!isManageMode"
                                        :href="document.external_url"
                                        class="fw-bold text-decoration-none"
                                        target="_blank"
                                    >
                                        {{ document.name }}
                                        <i class="fas fa-external-link-alt ms-1" style="font-size: 0.85em;"></i>
                                    </a>
                                    <a
                                        v-else
                                        href="#"
                                        class="fw-bold text-decoration-none"
                                        @click.prevent="editDocument(document)"
                                    >
                                        {{ document.name }}
                                        <i class="fas fa-pen ms-1" style="font-size: 0.85em;"></i>
                                    </a>
                                </h6>
                                <div class="text-muted small mb-1">
                                    {{ date(document.updated_at) }}
                                </div>
                                <p
                                    class="small mb-0 video-description"
                                    :class="{ 'overflow-visible': expandedDescriptions.has(document.id) }"
                                    :style="expandedDescriptions.has(document.id) ? 'max-height: 100%;' : ''"
                                >
                                    <span v-if="!document.description || document.description.length <= 60">
                                        {{ document.description }}
                                    </span>
                                    <span v-else>
                                        <span v-if="!expandedDescriptions.has(document.id)">
                                            {{ document.description.substring(0, 60).trim() }}...
                                            <a href="#" @click.prevent="toggleDescription(document.id)" class="text-primary text-decoration-none">more</a>
                                        </span>
                                        <span v-else class="text-break">
                                            {{ document.description }}
                                            <a href="#" @click.prevent="toggleDescription(document.id)" class="text-primary text-decoration-none">less</a>
                                        </span>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="documents.length > 6" class="chart-pagination-controls-container d-flex align-items-center justify-content-center gap-2 my-3">
                    <button
                        @click="moveToPrevPage(documents)"
                        :disabled="page_index === 0"
                        class="btn btn-sm btn-secondary"
                        title="Previous">
                        <i class="fas fa-chevron-left"></i>
                    </button>
                    <span>{{ formattedVideoPaginationText }}</span>
                    <button
                        @click="moveToNextPage(documents)"
                        :disabled="page_index >= page_count - 1"
                        class="btn btn-sm btn-secondary"
                        title="Next">
                        <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>
            <div v-else class="text-center py-4">
                No videos found
            </div>
        </div>
        <div class="card-body p-0" v-show="activeTab === 'documents'">
            <div class="table-card table-width-responsive" v-if="documents.length > 0" style="overflow-x: auto;">
                    <table class="table table-with-pagination mb-2" style="min-width: 100%;">
                    <thead>
                        <tr class="table-header-row">
                            <th @click="sortByKey('name')" class="d-table-cell" style="max-width: 280px; min-width: 150px;">
                                <div class="d-flex flex-row">
                                    Name
                                    <div class="d-flex flex-column">
                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'name' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="Sort ascending">
                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'name' && sort_order === 'des') ? 'sort-key-active' : ''" alt="Sort descending">
                                    </div>
                                </div>
                            </th>
                            <th @click="sortByKey('file_size')" class="d-none d-sm-table-cell">
                                <div class="d-flex flex-row">
                                    Size
                                    <div class="d-flex flex-column">
                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'file_size' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="Sort ascending">
                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'file_size' && sort_order === 'des') ? 'sort-key-active' : ''" alt="Sort descending">
                                    </div>
                                </div>
                            </th>
                            <th @click="sortByKey('file_type_name')" class="d-none d-md-table-cell d-lg-none d-xl-table-cell">
                                <div class="d-flex flex-row">
                                    Type
                                    <div class="d-flex flex-column">
                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'file_type_name' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="Sort ascending">
                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'file_type_name' && sort_order === 'des') ? 'sort-key-active' : ''" alt="Sort descending">
                                    </div>
                                </div>
                            </th>
                            <th @click="sortByKey('updated_at')" class="d-none d-xxl-table-cell">
                                <div class="d-flex flex-row">
                                    Created At
                                    <div class="d-flex flex-column">
                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'updated_at' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="Sort ascending">
                                        <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'updated_at' && sort_order === 'des') ? 'sort-key-active' : ''" alt="Sort descending">
                                    </div>
                                </div>
                            </th>
                            <th class="table-column-action d-table-cell column-sort-disabled pe-3" width="1" v-if="userStore.isAdmin || isManageMode">
                                <div class="d-flex flex-row">Action</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="document in documents" :key="document.id">
                            <td class="d-table-cell align-start" style="max-width: 280px; min-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" :title="document.name" data-bs-toggle="tooltip">
                                <template v-if="document.file_type === 'link'">
                                    <a :href="document.external_url" target="_blank" >
                                        {{ document.name }} <i class="fas fa-external-link-alt ms-1" style="font-size: 0.85em;"></i>
                                    </a>
                                </template>
                                <template v-else>
                                    <a href="#" @click.prevent="downloadDocument(document.id)">
                                        {{ document.name }} 
                                    </a>
                                </template>
                            </td>
                            <td class="d-none d-sm-table-cell">{{ document.file_size }}</td>
                            <td class="d-none d-md-table-cell d-lg-none d-xl-table-cell">{{ document.file_type_name }}</td>
                            <td class="d-none d-xxl-table-cell">
                                <span :title="datetime(document.updated_at)" data-bs-toggle="tooltip">
                                    {{ date(document.updated_at) }}
                                </span>
                            </td>
                            <td class="table-column-action d-table-cell" v-if="userStore.isAdmin || isManageMode">
                                <div class="dropdown d-flex justify-content-center">
                                    <button 
                                        class="btn btn-white btn-icon-only-md" 
                                        data-bs-toggle="dropdown" 
                                        data-bs-auto-close="true" 
                                        aria-expanded="false"
                                    >
                                        <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                        <a v-if="document.file_type !== 'link'" class="dropdown-item" href="#" @click.prevent="downloadDocument(document.id)">
                                            <img class="icon me-2" src="/img/icons/avid-icons/download.svg" alt=""> Download
                                        </a>
                                        <a v-else class="dropdown-item" :href="document.external_url" target="_blank">
                                            <img class="icon me-2" src="/img/icons/avid-icons/link.svg" alt=""> Open Link
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="editDocument(document)" v-if="userStore.isAdmin || isManageMode">
                                            <img class="icon me-2" src="/img/icons/avid-icons/edit.svg" alt=""> Edit
                                        </a>
                                        <hr class="my-1" v-if="userStore.isAdmin || isManageMode">
                                        <a class="dropdown-item text-danger" href="#" @click.prevent="deleteDocument(document.id)" v-if="userStore.isAdmin || isManageMode">
                                            <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt=""> Delete
                                        </a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-else class="text-center py-4">
                No documents found
            </div>
        </div>

        <!-- Add Document Modal -->
        <div class="modal fade" id="addDocumentModal" tabindex="-1" aria-labelledby="addDocumentModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="modal" data-bs-toggle="tooltip" title="Close">
                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2">Add {{ activeTab === 'videos' ? 'Video' : 'Document' }}</h3>
                        </div>
                    </div>
                    <div class="modal-body">
                        <nav class="navbar navbar-expand secondary-tab-bar mb-3" style="box-shadow: none;">
                            <ul class="navbar-nav">
                                <li class="nav-item">
                                    <a class="nav-link d-flex flex-nowrap secondary-tab"
                                        :class="{ 'secondary-tab-active': addModalTab === 'upload' }" href="#"
                                        @click.prevent="addModalTab = 'upload'">
                                        <span>Upload {{ activeTab === 'videos' ? 'Video' : 'Document' }}</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link d-flex flex-nowrap secondary-tab"
                                        :class="{ 'secondary-tab-active': addModalTab === 'external' }" href="#"
                                        @click.prevent="addModalTab = 'external'">
                                        <span>Add External {{ activeTab === 'videos' ? 'Video' : 'Document' }}</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>

                        <!-- Upload Document Tab -->
                        <div v-show="addModalTab === 'upload'">
                            <FileDropzone 
                                v-if="client && client.url"
                                :client-url="client.url" 
                                :on-file-uploaded="handleDocumentUploaded"
                                upload-method="proxy"
                                @uploadError="({ message }) => showNotification({ text: message, type: 'error' })"
                            ></FileDropzone>
                        </div>

                        <!-- Add External Document Tab -->
                        <div v-show="addModalTab === 'external'">
                            <form @submit.prevent="addExternalDocument">
                                <div class="mb-3">
                                    <label for="externalDocumentName" class="form-label">Name</label>
                                    <input type="text" class="form-control" id="externalDocumentName" v-model="externalDocument.name" required aria-label="Name">
                                </div>
                                <div class="mb-3">
                                    <label for="externalDocumentUrl" class="form-label">URL</label>
                                    <input type="url" class="form-control" id="externalDocumentUrl" v-model="externalDocument.url" required aria-label="URL">
                                </div>
                                <div class="mb-3">
                                    <label for="externalDocumentDescription" class="form-label">Description</label>
                                    <textarea class="form-control" id="externalDocumentDescription" v-model="externalDocument.description" rows="3" placeholder="Optional description of the document"></textarea>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button v-if="addModalTab === 'external'" type="button" class="btn btn-primary" @click="addExternalDocument" :disabled="form.adding">
                            <span v-if="form.adding" class="spinner-border spinner-border-sm me-2" role="status"></span>
                            {{ form.adding ? 'Adding...' : (activeTab === 'videos' ? 'Add Video' : 'Add Document') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit Document Modal -->
        <div class="modal fade" id="editDocumentModal" tabindex="-1" aria-labelledby="editDocumentModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editDocumentModalLabel">Edit Document</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="tooltip" title="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateDocument">
                            <div class="mb-3">
                                <label for="documentName" class="form-label">Document Name</label>
                                <input type="text" class="form-control" id="documentName" v-model="editingDocument.name" required aria-label="Document Name">
                            </div>
                            <div class="mb-3" v-if="editingDocument.file_type === 'link'">
                                <label for="externalUrl" class="form-label">External URL</label>
                                <input type="url" class="form-control" id="externalUrl" v-model="editingDocument.external_url" aria-label="External URL">
                            </div>
                            <div class="mb-3">
                                <label for="documentDescription" class="form-label">Description</label>
                                <textarea class="form-control" id="documentDescription" v-model="editingDocument.description" rows="3" placeholder="Optional description of the document"></textarea>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="updateDocument" :disabled="form.saving">
                            <span v-if="form.saving" class="spinner-border spinner-border-sm me-2" role="status"></span>
                            {{ form.saving ? 'Saving...' : 'Save Changes' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { defineComponent } from 'vue'
import { useLockstepStore } from '../../stores/lockstep'
import { useUserStore } from '../../stores/user'
import filtersMixin from '../../mixins/filters'
import tablePaginationMixin from '../../mixins/table_pagination'
import FileDropzone from '../components/FileDropzone.vue'
import Swal from 'sweetalert2';
import { useNotifications } from '../../composables/useNotifications';

export default defineComponent({
    mixins: [filtersMixin, tablePaginationMixin],
    name: 'Documents',
    components: {
        FileDropzone
    },
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    props: {
        client: {
            type: Object,
            required: true
        },
        isManageMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            lockstepStore: useLockstepStore(),
            userStore: useUserStore(),
            editingDocument: {
                id: null,
                name: '',
                external_url: '',
                file_type: '',
                description: ''
            },
            externalDocument: {
                name: '',
                url: '',
                description: ''
            },
            form: {
                saving: false,
                adding: false
            },
            sort_key: 'name',
            sort_order: 'asc',
            activeTab: 'videos',
            expandedDescriptions: new Set(),
            addModalTab: 'upload',
            num_per_page: 6,
        }
    },
    computed: {
        displayedVideos() {
            if (this.activeTab !== 'videos' || !this.documents.length) {
                return [];
            }
            if (this.documents.length <= 6) {
                return this.documents;
            }
            const start = this.page_index * this.num_per_page;
            const end = start + this.num_per_page;
            return this.documents.slice(start, end);
        },
        formattedVideoPaginationText() {
            if (this.documents.length <= 6 || this.page_count < 1) {
                return '';
            }
            return `Page ${this.page_index + 1} of ${this.page_count}`;
        },
        documents() {
            const allDocs = (this.lockstepStore.documents || []).filter(doc => doc.usage === 'external');
            
            if (this.activeTab === 'videos') {
                // Videos are links with external_url containing 'learn.avidai.com'
                const videos = allDocs.filter(doc => 
                    doc.file_type === 'link' && 
                    doc.external_url && 
                    (doc.external_url.includes('learn.avidai.com') || doc.external_url.includes('zoom') || doc.external_url.includes('fathom'))
                );
                return this.sortDocuments(videos);
            } else {
                // Documents are everything else (non-video links and uploaded files)
                const documents = allDocs.filter(doc => 
                    doc.file_type !== 'link' || 
                    !doc.external_url || 
                    !(doc.external_url.includes('learn.avidai.com') || doc.external_url.includes('zoom') || doc.external_url.includes('fathom'))
                );
                return this.sortDocuments(documents);
            }
        }
    },
    watch: {
        documents() {
            if (this.activeTab === 'videos' && this.documents.length > 6) {
                this.reloadPagination(this.documents);
            }
        },
        activeTab(tab) {
            if (tab === 'videos' && this.documents.length > 6) {
                this.reloadPagination(this.documents);
            }
        }
    },
    beforeMount() {
        // Initialize if data is available, otherwise wait for mounted
        if (window.__LOCKSTEP__) {
            this.lockstepStore.initialize(window.__LOCKSTEP__);
        }
    },
    mounted() {
        // Initialize if not already initialized (handles timing issues)
        if (!this.lockstepStore.isLoaded && window.__LOCKSTEP__) {
            this.lockstepStore.initialize(window.__LOCKSTEP__);
        }
        if (window.Echo) {
            this.lockstepStore.subscribeToEcho(window.Echo);
        }
        this.initializeDropdowns();
        if (this.activeTab === 'videos' && this.documents.length > 6) {
            this.reloadPagination(this.documents);
        }
    },
    updated() {
        // Reinitialize dropdowns when content updates
        this.$nextTick(() => {
            this.initializeDropdowns();
        });
    },
    beforeUnmount() {
        this.lockstepStore.unsubscribeFromEcho(window.Echo);
    },
    methods: {
        initializeDropdowns() {
            // Initialize dropdowns with proper boundary to escape overflow containers
            // This fixes the issue on Windows where dropdowns get clipped by overflow containers
            this.$nextTick(() => {
                const dropdownElements = this.$el.querySelectorAll('[data-bs-toggle="dropdown"]');
                dropdownElements.forEach(element => {
                    // Skip if already initialized
                    if (bootstrap.Dropdown.getInstance(element)) {
                        return;
                    }
                    
                    // Initialize with boundary set to viewport to escape overflow containers
                    new bootstrap.Dropdown(element, {
                        boundary: 'viewport'
                    });
                });
            });
        },
        openAddDocumentModal() {
            // Reset form and set default tab
            this.externalDocument = {
                name: '',
                url: '',
                description: ''
            };
            this.addModalTab = 'upload';
            this.form.adding = false;
            
            // Show the modal
            const modal = new bootstrap.Modal(window.document.getElementById('addDocumentModal'));
            modal.show();
        },
        handleDocumentUploaded(uploadedDocument) {
            // The FileDropzone component calls the callback with the document data
            // Add the document to the store if it doesn't already exist
            if (uploadedDocument && uploadedDocument.id) {
                const existingIndex = this.lockstepStore.documents.findIndex(doc => doc.id === uploadedDocument.id);
                if (existingIndex === -1) {
                    // Add to store with usage: 'external' if not set
                    const docToAdd = {
                        ...uploadedDocument,
                        usage: uploadedDocument.usage || 'external'
                    };
                    this.lockstepStore.documents.push(docToAdd);
                }
            }
            
            // Close the modal immediately after API success
            this.$nextTick(() => {
                const modalElement = window.document.getElementById('addDocumentModal');
                if (modalElement) {
                    const modal = bootstrap.Modal.getInstance(modalElement);
                    if (modal) {
                        modal.hide();
                    }
                }
            });
            
            // Show success message
            this.showNotification({
                text: 'The document has been uploaded successfully!'
            });
        },
        addExternalDocument() {
            if (!this.client || !this.client.url) {
                Swal.fire({
                    title: 'Error',
                    text: 'Client information is not available.',
                    icon: 'error',
                    customClass: {
                        popup: 'swal-error'
                    }
                });
                return;
            }

            if (!this.externalDocument.name.trim() || !this.externalDocument.url.trim()) {
                Swal.fire({
                    title: 'Error',
                    text: 'Name and URL are required.',
                    icon: 'error',
                    customClass: {
                        popup: 'swal-error'
                    }
                });
                return;
            }

            // Close the modal immediately after submit
            const modalElement = window.document.getElementById('addDocumentModal');
            if (modalElement) {
                const modal = bootstrap.Modal.getInstance(modalElement);
                if (modal) {
                    modal.hide();
                }
            }

            // Save form data before resetting
            const documentData = {
                name: this.externalDocument.name,
                url: this.externalDocument.url,
                description: this.externalDocument.description
            };

            // Reset form
            this.externalDocument = {
                name: '',
                url: '',
                description: ''
            };

            this.form.adding = true;
            
            window.axios.post('/api/document/save', {
                file_name: documentData.name,
                content_type: 'link',
                content_size: 0,
                external_url: documentData.url,
                description: documentData.description,
                usage: 'external',
                client_url: this.client.url
            })
            .then(response => {
                this.form.adding = false;
                
                // Add the document to the store
                if (response.data.document && !this.lockstepStore.documents.find(doc => doc.id === response.data.document.id)) {
                    this.lockstepStore.documents.push(response.data.document);
                }
                
                // Show success message
                this.showNotification({
                    text: '<strong>' + response.data.document.name + '</strong> has been added!'
                });
            })
            .catch(error => {
                this.form.adding = false;
                console.error('Error adding external document:', error);
                
                Swal.fire({
                    title: 'Error',
                    text: error.response?.data?.message || 'There was an error adding the document. Please try again.',
                    icon: 'error',
                    customClass: {
                        popup: 'swal-error'
                    }
                });
            });
        },
        sortByKey(key) {
            if (this.sort_key !== key) {
                this.sort_key = key;
                this.sort_order = 'asc'; // reset to ascending sorting order
            } else {
                this.sort_order = (this.sort_order === 'asc' ? 'des' : 'asc');
            }
        },
        sortDocuments(documents) {
            if (!documents || documents.length === 0) return documents;
            
            return [...documents].sort((a, b) => {
                let aValue = a[this.sort_key];
                let bValue = b[this.sort_key];
                
                // Handle special cases for sorting
                if (this.sort_key === 'file_size') {
                    // Convert file size strings to numbers for proper sorting
                    aValue = this.parseFileSize(aValue);
                    bValue = this.parseFileSize(bValue);
                } else if (this.sort_key === 'updated_at') {
                    // Convert dates to Date objects for proper sorting
                    aValue = new Date(aValue);
                    bValue = new Date(bValue);
                }
                
                // Handle null/undefined values
                if (aValue == null && bValue == null) return 0;
                if (aValue == null) return this.sort_order === 'asc' ? -1 : 1;
                if (bValue == null) return this.sort_order === 'asc' ? 1 : -1;
                
                // Compare values
                if (aValue < bValue) return this.sort_order === 'asc' ? -1 : 1;
                if (aValue > bValue) return this.sort_order === 'asc' ? 1 : -1;
                return 0;
            });
        },
        parseFileSize(sizeString) {
            if (!sizeString || sizeString === '--') return 0;
            
            const units = { 'B': 1, 'KB': 1024, 'MB': 1024 * 1024, 'GB': 1024 * 1024 * 1024, 'TB': 1024 * 1024 * 1024 * 1024 };
            const match = sizeString.match(/^([\d.]+)\s*([A-Z]+)$/);
            
            if (match) {
                const value = parseFloat(match[1]);
                const unit = match[2];
                return value * (units[unit] || 1);
            }
            
            return 0;
        },
        switchTab(tab) {
            this.activeTab = tab;
        },
        truncateDescription(text, maxLength = 120) {
            if (!text || text.length <= maxLength) return text;
            return text.substring(0, maxLength).trim() + '...';
        },
        toggleDescription(documentId) {
            if (this.expandedDescriptions.has(documentId)) {
                this.expandedDescriptions.delete(documentId);
            } else {
                this.expandedDescriptions.add(documentId);
            }
        },
        downloadDocument(documentId) {
            const client = this.lockstepStore.client;
            location.href = `/documents/${client.url}/${documentId}`;
        },
        editDocument(doc) {
            this.editingDocument = {
                id: doc.id,
                name: doc.name,
                external_url: doc.external_url || '',
                file_type: doc.file_type,
                description: doc.description || ''
            };
            
            // Show the modal
            const modal = new bootstrap.Modal(window.document.getElementById('editDocumentModal'));
            modal.show();
        },
        updateDocument() {
            if (!this.editingDocument.name.trim()) {
                Swal.fire({
                    title: 'Error',
                    text: 'Document name is required.',
                    icon: 'error',
                    customClass: {
                        popup: 'swal-error'
                    }
                });
                return;
            }

            this.form.saving = true;
            const client = this.lockstepStore.client;
            
            window.axios.put(`/api/document/${client.url}/${this.editingDocument.id}`, {
                name: this.editingDocument.name,
                external_url: this.editingDocument.external_url,
                description: this.editingDocument.description
            })
            .then(response => {
                this.form.saving = false;
                
                // Update the document in the store
                const documentIndex = this.lockstepStore.documents.findIndex(doc => doc.id === this.editingDocument.id);
                if (documentIndex !== -1) {
                    // Update the document in the store with proper reactivity
                    this.lockstepStore.documents.splice(documentIndex, 1, response.data.document);
                }
                
                // Close the modal
                const modal = bootstrap.Modal.getInstance(window.document.getElementById('editDocumentModal'));
                modal.hide();
                
                this.showNotification({
                    text: '<strong>' + this.editingDocument.name + '</strong> has been updated!'
                });
            })
            .catch(error => {
                this.form.saving = false;
                console.error('Error updating document:', error);
                
                Swal.fire({
                    title: 'Error',
                    text: 'There was an error updating the document. Please try again.',
                    icon: 'error',
                    customClass: {
                        popup: 'swal-error'
                    }
                });
            });
        },
        deleteDocument(documentId) {
            const client = this.lockstepStore.client;
            Swal.fire({
                title: 'Are you sure you want to delete this document?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete',
                customClass: {
                    popup: 'swal-warning'
                },
            }).then((result) => {
                if (result.isConfirmed) {   
                    window.axios.delete(`/api/document/${client.url}/${documentId}`)
                        .then(response => {
                            // console.log(response);
                            const document = this.lockstepStore.documents.find(doc => doc.id === documentId);
                            const documentName = document?.name || 'Document';
                            this.showNotification({
                                text: '<strong>' + documentName + '</strong> was deleted!'
                            });
                            // Remove the document from the store
                            const documentIndex = this.lockstepStore.documents.findIndex(doc => doc.id === documentId);
                            if (documentIndex !== -1) {
                                this.lockstepStore.documents.splice(documentIndex, 1);
                            }
                            
                            
                        })
                        .catch(error => {
                            console.error('Error deleting document:', error);
                            Swal.fire({
                                title: 'Error',
                                text: 'There was an error deleting the document. Please try again.',
                                icon: 'error',
                                customClass: {
                                    popup: 'swal-error'
                                }
                            });
                        });
                }
            });
        }
    }
})
</script>
